var map = {
	"./assets/Add.svg": "5b7b",
	"./assets/AppStore.svg": "c9d7",
	"./assets/Cog.svg": "7568",
	"./assets/GuusEnter.svg": "afcb",
	"./assets/GuusFlying.svg": "5e0a",
	"./assets/MainLogo.svg": "f4f4",
	"./assets/MenuKebabBlack.svg": "e76c",
	"./assets/MicrosoftLogin.svg": "d5ac",
	"./assets/PlayStore.svg": "2796",
	"./assets/Save.svg": "8c9c",
	"./assets/TableSort.svg": "ebbf",
	"./assets/User.svg": "cf4a",
	"./assets/android.svg": "ac89",
	"./assets/chevron.svg": "ac6d",
	"./assets/chevronRight.svg": "0b8f",
	"./assets/download.svg": "6369",
	"./assets/iOS.svg": "6d5e",
	"./assets/invoice.svg": "04e8",
	"./assets/linux.svg": "b188",
	"./assets/logout.svg": "309a",
	"./assets/macOS.svg": "cad2",
	"./assets/menu-kebab.svg": "fa70",
	"./assets/router.svg": "097a",
	"./assets/windows.svg": "d148"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1568";